<template>
 <v-row row wrap>

    <v-col cols="12" >
        <v-row justify="space-between">
            <v-col cols="12" sm="6" md="8">
             <!-- FILTERS HERE -->
            </v-col>
            <v-col cols="12" sm="6" md="4">
            <search-input  @search="performSearch" v-model="search" />
            </v-col>
        </v-row>
    </v-col>

    <v-col cols="12">

       <v-data-table
                class="mt-3"
                :headers="headers"
                :items="items"
                :search="search"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
        >




         <template v-slot:item.fecha="{ item }">
            {{getDateTimeCustomFormat(item.fecha, 'YYYY-MM','America/Argentina/Buenos_Aires')}}
         </template>

         <template v-slot:item.cerrada="{ item }">
           <div v-if="item.cerrada">
             <v-chip>  <v-icon color="red" left>no_meeting_room</v-icon> Cerrada </v-chip>

           </div>
           <div v-else>
             <v-chip>  <v-icon color="green" left>meeting_room</v-icon> Abierta </v-chip>
           </div>
         </template>

            <template slot="no-data">
               <div class="text-xs-center" v-t="'common.noData'"></div>
            </template>

            <template slot="loading">
               <div   class="text-xs-center" v-t="'common.loading'"></div>
            </template>

            <template v-slot:item.action="{ item }">
                <show-button v-if="false"  @click="$emit('show', item)" />
                <edit-button v-if="$store.getters.hasPermission('CAJAMENSUAL_UPDATE')"  @click="$emit('update', item)" />
                <delete-button v-if="false && $store.getters.hasPermission('CAJAMENSUAL_DELETE')" @click="$emit('delete', item)" />
            </template>

        </v-data-table>
    </v-col>
</v-row>
</template>

<script>
   import CajaMensualProvider from "../../../../providers/CajaMensualProvider";

   import {DeleteButton, EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"
   import {DayjsMixin} from "@dracul/dayjs-frontend";

    export default {
        name: "CajaMensualList",
        components: {DeleteButton, EditButton, ShowButton, SearchInput},
        mixins: [DayjsMixin],
        data() {
            return {
                items: [],
                totalItems: null,
                loading: false,
                orderBy: 'fecha',
                orderDesc: true,
                itemsPerPage: 5,
                pageNumber: 1,
                search: '',
                filters: [
                    /*{
                        field: '',
                        operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
                        value: ''
                    }*/
                ]
            }
        },
        computed: {
          headers () {
            return [
                    //Entity Headers
                    {text: this.$t('cobrox.cajaMensual.labels.fecha'), value: 'fecha'},
                    {text: this.$t('cobrox.cajaMensual.labels.estado'), value: 'cerrada'},
                    //Actions
                    {text: this.$t('common.actions'), value: 'action', sortable: false},
                ]
          },
          getOrderBy(){
              return  (Array.isArray(this.orderBy)) ? this.orderBy[0]: this.orderBy
          },
          getOrderDesc(){
              return  (Array.isArray(this.orderDesc)) ? this.orderDesc[0]: this.orderDesc
          }
        },
        created() {
            this.fetch()
        },
        methods:{
            performSearch(){
                this.pageNumber = 1
                this.fetch()
            },
            fetch() {
                this.loading = true
                CajaMensualProvider.paginateCajaMensual(
                    this.pageNumber,
                    this.itemsPerPage,
                    this.search,
                    this.filters,
                    this.getOrderBy,
                    this.getOrderDesc
                ).then(r => {
                    this.items = r.data.paginateCajaMensual.items
                    this.totalItems = r.data.paginateCajaMensual.totalItems
                }).catch(err => {
                    console.error(err)
                }).finally(() => this.loading = false)
            }
        }

    }
</script>


